import {fetchWorker} from "./util.js"
import Url from './url.js'
import {bus} from './bus.js'

export default class Search {
  constructor(workerUrl) {
    this.workerUrl = workerUrl
    this.messageId = 10000
    this.resolveMap = {}
    this.initWorker()
    this.count = 0
  }

  getCount() {
    return this.count
  }

  initWorker() {
    this.initPromise = this.initPromise || (
      this.useFetchForWorker() ?
      this.fetchWorker() :
      this.instantiateWorker()
    )

    console.log('worker promise: ', this.initPromise)

    return this.initPromise
  }

  useFetchForWorker() {
    const cu = Url.current()
    const wu = Url.parse(this.workerUrl)

    return cu.origin() != wu.origin()
  }

  fetchWorker() {
    return fetchWorker(this.workerUrl).then(worker => {
      worker.onmessage = event => this.onResponse(event)
      this.worker = worker
      return this.worker
    })
  }

  instantiateWorker() {
    return new Promise((resolve, reject) => {
      this.worker = new Worker(this.workerUrl)
      this.worker.onmessage = event => this.onResponse(event)
      resolve(this.worker)
    })
  }

  onResponse(event) {
    const data = event.data

    const resolve = this.resolveMap[data.messageId]
    if (resolve) {
      delete this.resolveMap[data.messageId]
      this.updateCount(-1)
      resolve(data)
    }
  }

  query(criteria) {
    return this.postMessage({action: 'query', criteria})
  }

  ready() {
    return this.postMessage({action: 'counts'})
  }

  updateCount(by) {
    this.count += by
    bus.emit('search-count-change', {count: this.count})
  }

  postMessage(data) {
    return this.initPromise.then(() => {
      const newId = this.messageId
      this.messageId += 1

      const promise = new Promise((resolve, reject) => {
        this.resolveMap[newId] = resolve
        this.updateCount(1)

        data.messageId = newId
        this.worker.postMessage(data)
      })

      return promise
    })
  }
}
